import { Component, SessionService } from "../../../core/index";

import orderStatus from "./order-status.scss";
import checkmark from "../checkmark/checkmark.scss";
import failmark from "../failmark/failmark.scss";
import template from "./order-status.html";

const styles = {
    orderStatus: orderStatus,
    checkmark: checkmark,
    failmark: failmark
};

@Component({
    selector: "becOrderStatus",
    template,
    bindings: {
        isSuccess: "<"
    },
    transclude: true
})
export class OrderStatus {
    static $inject = ["SessionService"];

    constructor(public session: SessionService) {}

    styles = styles;
    isSuccess: boolean;
}
